import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthServices } from "../../auth/services";
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HomePage } from '../../home/home';

/**
 * Generated class for the SetupInitalData2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-setup-inital-2',
    templateUrl: 'setup-inital-2.html',
})
export class SetupInital2Page {

    public form: any;
    type: any = '';
    type_msg: any = '';

    constructor(public fb: FormBuilder,
        public navCtrl: NavController,
        public navParams: NavParams,
        private authServices: AuthServices,
        private toastCtrl: ToastController,
        private globals: Globals,
        public translate: TranslateService,
        private http: HttpClient,) {
        this.form = fb.group({
            currency: [(this.globals.restaurant.currency || 'Euro (EUR)'), Validators.compose([Validators.required])],
            tax_name: [(this.globals.restaurant.tax_name || 'IVA'), Validators.compose([Validators.required])],
            tax_percentage: [(this.globals.RESTAURANT_TAX || '10'), Validators.compose([Validators.required])],
            timezone: [(this.globals.restaurant.timezone || 'Europe/Madrid'), Validators.compose([Validators.required])],
            format_time: [(this.globals.restaurant.format_time || 'HH:mm:ss'), Validators.compose([Validators.required])],
            format_date: [(this.globals.restaurant.format_date || 'd/MM/yyyy'), Validators.compose([Validators.required])],
            tips: [(this.globals.restaurant.tips || false), Validators.compose([Validators.required])],
            tip_1: [(this.globals.restaurant.tip_1 || 0), Validators.compose([Validators.required])],
            tip_2: [(this.globals.restaurant.tip_2 || 0), Validators.compose([Validators.required])],
            tip_3: [(this.globals.restaurant.tip_3 || 0), Validators.compose([Validators.required])],
        });
    }

    saveForm() {
        if (this.type_msg == '') {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-selecciona-una-opcion'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
        } else {
            this.globals.register_start_by = this.type_msg;
            //Si la variable se ha llenado en el setup2 substitumos la del restaurante (elimanamos persona_3, persona_2, persona_1)
            if (this.globals.register_buyer_person != undefined && this.globals.register_buyer_person != '') {
                this.globals.restaurant.buyer_person = this.globals.register_buyer_person;
            }
            this.updateData();
        }
    }

    async updateData() {
        //Insertamos en collection _data que hay nuevo Registro
        await this.globals.sendDataToDataCollection('register', []);
        //Send to bigquery
        this.globals.sendToBigqueryRegister('setup2');
        this.sendSlackRegisterSetup2();

        this.authServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            currency: this.form.value.currency,
            tax_name: this.form.value.tax_name,
            tax_percentage: this.form.value.tax_percentage,
            timezone: this.form.value.timezone,
            tips: this.form.value.tips,
            tip_1: this.form.value.tip_1,
            tip_2: this.form.value.tip_2,
            tip_3: this.form.value.tip_3,
            format_time: this.form.value.format_time,
            format_date: this.form.value.format_date,
            register_start_by: this.type_msg,
            register_step: 'completed'
        }).then(async value => {
            this.globals.restaurant.register_step = 'completed';
            //Enviar informacion nueva del restaurante al node para actualizar hubspot
            this.globals.updateERPNextCustomer();

            var str = this.form.value.currency;

            this.globals.user_currency = str.substring(str.lastIndexOf("(") + 1,
                str.lastIndexOf(")"));
            this.globals.user_tax_name = this.form.value.tax_name;
            this.globals.user_tax = this.form.value.tax_percentage;
            this.globals.user_timezone = this.form.value.timezone;
            this.globals.RESTAURANT_TAX = this.form.value.tax_percentage;
            await this.globals.getRestaurant(this.globals.restaurant_uid);
            this.navCtrl.setRoot(HomePage);
        });

    }

    async sendSlackRegisterSetup2() {
        //generate msg
        var msg = 'Registro completado del establecimiento: ' + (this.globals.register_company || this.globals.restaurant.company) +
            ' - Contacto: ' + (this.globals.register_contact || this.globals.restaurant.name) + ' ' + (this.globals.register_phone || this.globals.restaurant.phone) + ' ' + this.globals.user_email +
            ' - Dirección: ' + (this.globals.register_address || this.globals.restaurant.address) +
            ' - Tipo: ' + (this.globals.register_business || this.globals.getBusinessType(this.globals.restaurant.business)) +
            ' - Establecimientos: ' + (this.globals.register_stores || this.globals.restaurant.plg_register_stores) +
            ' - Trabajadores: ' + (this.globals.register_workers || this.globals.restaurant.plg_register_workers) +
            ' - Nuevo negocio: ' + (this.globals.register_new_business || this.globals.restaurant.plg_register_new_business) +
            ' - Trabajaba con: ' + (this.globals.register_worked_so_far || this.globals.restaurant.plg_register_is_digital) +
            ' - Quiere empezar con: ' + (this.globals.register_start_by || this.globals.restaurant.register_start_by) +
            ' - Buyer person: ' + this.globals.restaurant.buyer_person;
        //send
        await this.http.post(this.globals.api_path + 'slack/register', {
            msg: msg,
        }, {}).subscribe(async data => {
        },
            err => {
            }
        );
    }
    selectType(type) {
        var select = undefined;
        switch (type) {
            case 'setup2_cartas_menus':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('setup2_cartas_menus').classList.add('selected');
                this.type = 'menus';
                this.type_msg = 'Carta y menús';
                break;
            case 'setup2_delivery':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('setup2_delivery').classList.add('selected');
                this.type = 'delivery';
                this.type_msg = 'Pedidos online';
                break;
            case 'setup2_reservas':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('setup2_reservas').classList.add('selected');
                this.type = 'reservas';
                this.type_msg = 'Reservas';
                break;
            case 'setup2_tpv_orders_kds':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('setup2_tpv_orders_kds').classList.add('selected');
                this.type = 'pos';
                this.type_msg = 'POS, Orders y KDS';
                break;
            case 'setup2_stock':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('setup2_stock').classList.add('selected');
                this.type = 'stock';
                this.type_msg = 'Stock y escandallos';
                break;
            case 'setup2_all':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('setup2_all').classList.add('selected');
                this.type = 'all';
                this.type_msg = 'Todos';
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/setup/setup-initial-2/setup-inital-2.ts